import Prose from '@components/Prose';
import RadialChart from '@components/RadialChart';
import ResultsKey from '@components/ResultsKey';
import ResultNextComponentMessage from '@components/ResultsNextComponentMessge';
import { ResultsYourResultsType } from '@data/types';
import useQuestionnaireStore from '@store/questionnaire';
import React, { useMemo } from 'react';
import { getAllScores, getRegion } from 'utilities/scores';

interface Props extends ResultsYourResultsType {
  as?: keyof JSX.IntrinsicElements;
}

const ResultsYourResults: React.FC<Props> = ({
  as: Component = 'div',
  htmlContent,
}) => {
  const { pillarsStore } = useQuestionnaireStore();

  const { region, data } = useMemo(
    function () {
      const region = getRegion(pillarsStore);

      return {
        region,
        data: getAllScores(pillarsStore, region),
      };
    },
    [pillarsStore]
  );

  return (
    <Component
      className="results-your-results w-full bg-gradient-to-b from-[#242149] to-blue flex flex-col"
      data-pdf-page
    >
      <div className="flex flex-col flex-grow">
        <div className="px-4 pt-8 pb-16 xl:px-0 w-full max-w-outerGrid h-full flex justify-center items-center gap-4 flex-col lg:flex-row mx-auto mt-auto">
          <div className="w-full h-full lg:w-2/5">
            <Prose htmlContent={htmlContent} style="style-5" />

            <div className="mt-4">
              <hr className="border-white w-1/2 mb-16" />
              <ResultsKey region={region} />
            </div>
          </div>
          <figure className="w-full lg:w-3/5 text-white md:p-12">
            <div className="max-w-[36rem] mx-auto">
              <RadialChart region={region} data={data} />
            </div>
          </figure>
        </div>
        <div className="hidden lg:flex w-full mt-auto -translate-y-[4vh]">
          <ResultNextComponentMessage message="See your pillar scores" />
        </div>
      </div>
    </Component>
  );
};

export default ResultsYourResults;
